<template>
  <div class="container-subscribe">
    <div class="step-progress">
      <div class="progress-container">
        <div class="progress"></div>
        <div class="circle active">{{ DOMAIN_NAME !== domainNameCurrent ? $t("new.title162") : $t("new.title292") }}</div>
        <div v-if="totalPrice >= 0 && DOMAIN_NAME !== domainNameCurrent" class="circle active">{{ $t("new.title164") }}</div>
        <div v-else class="circle active">{{ DOMAIN_NAME !== domainNameCurrent ? $t("new.title228") : $t("new.title293") }}</div>
        <div class="circle">{{ $t("new.title163") }}</div>
      </div>
    </div>
    <div class="subscribe" v-if="DOMAIN_NAME !== domainNameCurrent">
      <h3 class="subscribe-success">{{ $t("new.title178") }}</h3>
      <div v-if="outlineInfo.totalPrice > 0" class="main">
        <div class="content-notifi">
          <p>{{ $t("new.title179") }}</p>
        </div>
        <div class="infor-customer">
          <div class="info">
            <table class="table-info">
              <tr>
                <td>{{ $t("new.title170") }}:</td>
                <td><span>{{ outlineInfo.name }}</span></td>
              </tr>
              <tr>
                <td>{{ $t("new.title171") }}:</td>
                <td><span>{{ outlineInfo.email }}</span></td>
              </tr>
              <tr>
                <td>{{ $t("new.title172") }}:</td>
                <td><span>{{ outlineInfo.mobile }}</span></td>
              </tr>
            </table>
          </div>
          <!-- <div class="transfer-code">
            <p>{{ $t("new.title204") }}:</p>
            <div class="code">
              <p>
                <span>{{ outlineInfo.code }}</span>
              </p>
            </div>
          </div> -->
        </div>
        <!-- <div class="content-remind">
          <p>{{ $t("new.title180") }}</p>
        </div> -->
        <!-- <div class="transfer-total" >
          <p>
            {{ $t("new.title205") }}:<span v-if="beforeCurren">{{
              $t("new.title121")
            }}</span>
            {{
              outlineInfo.totalPrice
                .toString().replace('.00', '')
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }}
            <span v-if="afterCurren">{{ $t("new.title121") }}</span>
          </p>
        </div> -->
        <div class="button-back">
          <!-- <button id="export" @click="exportInfoSubscribe()">
            {{ $t("new.title206") }}
          </button> -->
          <button @click="nextBackCourse()">{{ $t("new.title225") }}</button>
        </div>
      </div>
      <div v-else class="main">
        <div class="content-notifi">
          <p>{{ $t("new.title179") }}</p>
        </div>
        <div class="infor-customer">
          <div class="info">
            <table class="table-info">
              <tr>
                <td>{{ $t("new.title170") }}:</td>
                <td><span>{{ outlineInfo.name }}</span></td>
              </tr>
              <tr>
                <td>{{ $t("new.title171") }}:</td>
                <td><span>{{ outlineInfo.email }}</span></td>
              </tr>
              <tr>
                <td>{{ $t("new.title172") }}:</td>
                <td><span>{{ outlineInfo.mobile }}</span></td>
              </tr>
            </table>
          </div>
        </div>
        <div class="button-back">
          <button @click="nextBackCourse()">{{ $t("new.title225") }}</button>
        </div>
      </div>
      <!-- <section class="main-section" v-if="outlineInfo.totalPrice >= 0">
        <div class="header-tab">
          <h3>{{ $t("new.title165") }}</h3>
        </div>
        <div class="detail-pay">
          <div class="bankLists">
            <dir class="bank bank-new">
              <ul class="clear">
                <li id="hidden"></li>
                <li v-for="(item, index) in dataRender" :key="index">
                  <div class="bank-info">
                    <div class="bank-change">
                      <span
                        ><b>{{ $t("new.title226") }}</b></span
                      >
                      <select v-model="activeBank" class="multiple_select_exam">
                        <option
                          v-for="(bankItem, index) in item.bankInfo"
                          :value="bankItem"
                          :key="index"
                          >{{ bankItem.nameBank }}</option
                        >
                      </select>
                    </div>
                    <div class="bank__info__detail">
                      <div class="bank-logo"></div>
                      <div class="bank-name">
                        <p>
                          <b>{{ bank[index].nameBank }}</b>
                        </p>
                        <p>
                          {{ $t("new.title223") }}: <br />
                          <span
                            ><b>{{ bank[index].nameAccount }}</b></span
                          >
                        </p>
                        <p>
                          {{ $t("new.title166") }}: <br /><span
                            ><b>{{ bank[index].numberBank }}</b></span
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="lessons">
                  <template v-for="(course, index) in item.courseInfo">
                      <div
                      class="lessons-info" :key="index" v-if="course.price>=0"
                    >
                      <div class="lessons-name">
                        <span>{{ ++index }}</span>
                        <span>{{ course.courseName }}</span>
                      </div>
                      <div
                        class="Stars"
                        :style="'--rating:' + course.courseEvaluate"
                      ></div> -->
                      <!-- Sao đánh giá -->
                      <!-- <div class="lessons-price">
                        <span data-label="$t('new.title177')">
                          <span v-if="beforeCurren">{{ $t("new.title121") }}</span>
                          {{
                            course.price
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          }}
                          <span v-if="afterCurren">{{ $t("new.title121") }}</span>
                          </span
                        > -->
                        <!-- <span v-if="item.offSelf !=0" :data-label="$t('new.title177')"><span v-if="beforeCurren">{{ $t("new.title121") }}</span> {{(item.coursePrice-item.coursePriceDiscount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}} <span v-if="afterCurren">{{ $t("new.title121") }}</span></span>
                                                <span v-else :data-label="$t('new.title177')"><span v-if="beforeCurren">{{ $t("new.title121") }}</span> {{(item.coursePrice).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}} <span v-if="afterCurren">{{ $t("new.title121") }}</span></span> -->
                      <!-- </div>
                    </div>
                  </template>
                    <div class="synthetic" v-if="item.totalPrice >= 0">
                      <span class="ty"
                        ><span class="total_money"
                          >{{ $t("new.title155") }}: </span
                        ><span class="total_money"
                          ><span v-if="beforeCurren">
                            {{ $t("new.title121") }}</span
                          >
                          {{
                            parseFloat(item.totalPrice).toFixed(2)
                              .toString().replace('.00', '')
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          }}
                          <span v-if="afterCurren" class="total_money">{{
                            $t("new.title121")
                          }}</span></span
                        ></span
                      >
                    </div>
                  </div>
                </li>
              </ul>
            </dir>
          </div>
        </div>
      </section> -->
    </div>
    <div class="subscribe" v-else>
      <h3 class="subscribe-success">{{ !isInsert ? $t("new.title275") : $t("new.title178")}}</h3>
      <div class="main">
        <div v-if="DOMAIN_NAME !== domainNameCurrent" class="content-notifi">
          <p>{{ $t("new.title179") }}</p>
        </div>
        <div v-if="!isInsert" class="content-notifi">
          <p>{{ $t("new.title276") }}</p>
        </div>
        <div v-else class="content-notifi-tokyo">
          <div>
            <p>{{ $t("new.title250") }}</p>
            <p>{{ $t("new.title251") }}</p>
          </div>
        </div>
        <div class="infor-customer">
          <div class="info">
            <table class="table-info">
              <tr>
                <td v-if="DOMAIN_NAME !== domainNameCurrent">{{ $t("new.title170") }}:</td>
                <td v-else style="font-weight: bold;">{{ $t("new.title252") }}</td>
                <td><span>{{ outlineInfo.name }}</span></td>
              </tr>
              <tr>
                <td v-if="DOMAIN_NAME !== domainNameCurrent">{{ $t("new.title171") }}:</td>
                <td v-else style="font-weight: bold;">{{ $t("new.title253") }}</td>
                <td><span>{{ outlineInfo.email }}</span></td>
              </tr>
              <tr>
                <td v-if="DOMAIN_NAME !== domainNameCurrent">{{ $t("new.title172") }}:</td>
                <td v-else style="font-weight: bold;">{{ $t("new.title172") }}:</td>
                <td><span>{{ outlineInfo.mobile }}</span></td>
              </tr>
            </table>
          </div>
          <div class="transfer-code" v-if="DOMAIN_NAME !== domainNameCurrent">
            <!-- <p>{{ $t("new.title204") }}:</p>
            <div class="code">
              <p>
                <span>{{ outlineInfo.code }}</span>
              </p>
            </div> -->
          </div>
          <div v-else class="region">
            <div class="region-bank">
              <span class="region-title" style="padding-top: 5px;">{{ $t("new.title254") }}</span>
              <ul>
                <li v-for="(item, index) in dataRender" :key="index">
                  <select v-model="activeBank" class="multiple_select_exam" style="padding: 0.5em;" :disabled="isDisabled">
                          <option
                            v-for="(bankItem, index) in item.bankInfo"
                            :value="bankItem"
                            :key="index"
                            >{{ bankItem.nameBank }}</option
                          >
                  </select>
                  <div class="bank__info__detail bank__info__content">
                    <table>
                      <tr>
                        <td style="text-align: right;"><span>{{ $t("new.title273") }}</span></td>
                        <td style="text-align: left;" class="info-bank-content"><span>{{ bank[index].nameBank }}</span></td>
                      </tr>
                      <tr>
                        <td style="text-align: right;"><span>{{ $t("new.title255") }}</span></td>
                        <td style="text-align: left;" class="info-bank-content"><span>{{ bank[index].numberBank }}</span></td>
                      </tr>
                      <tr>
                        <td style="text-align: right;"><span> {{ $t("new.title256") }}</span></td>
                        <td style="text-align: left;" class="info-bank-content"><span>{{ bank[index].nameAccount }}</span></td>
                      </tr>
                    </table>
                    </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- <div class="content-remind">
          <p v-if="DOMAIN_NAME !== domainNameCurrent">{{ $t("new.title180") }}</p>
        </div> -->
        <!-- <div class="transfer-total" v-if="outlineInfo.totalPrice > 0">
          <p>
            {{ $t("new.title205") }}:<span v-if="beforeCurren">{{
              $t("new.title121")
            }}</span>
            {{
              outlineInfo.totalPrice
                .toString().replace('.00', '')
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }}
            <span v-if="afterCurren">{{ $t("new.title121") }}</span>
          </p>
        </div> -->
        <div class="button-back">
          <!-- <button id="export" @click="exportInfoSubscribe()" v-if="DOMAIN_NAME !== domainNameCurrent">
            {{ $t("new.title206") }}
          </button> -->
          <button @click="nextBackCourse()">{{ $t("new.title225") }}</button>
          <div class="button-insert-pdf">
              <button @click="insertCourseRegisterUser()" v-if="DOMAIN_NAME === domainNameCurrent && !isInsert">
              {{ $t('new.title182') }}
            </button>
            <button id="export" @click="convertToPdf()" v-if="DOMAIN_NAME === domainNameCurrent && isInsert">
              {{ $t("new.title257") }}
            </button>
            <div class="info-contact" v-if="isInsert">
              <span> {{ $t("new.title281") }} </span>
              <span> {{ $t("new.title282") }}{{ mailto }}</span>
          </div>
          </div>
        </div>
      </div>
      <section class="main-section">
      <div>
        <div style="display: none;" ref="pdfWrapper">
          <exportToPdf :bank="bank" :QRCODE="QRCODE"></exportToPdf>
          <br/>
        </div>
      </div>
        <div class="detail-pay">
          <div class="bankLists">
            <dir class="bank bank-new">
              <ul class="clear">
                <li id="hidden"></li>
                <li v-for="(item, index) in dataRender" :key="index" :class="{'bankLists-export_pdf': DOMAIN_NAME == domainNameCurrent}">
                  <div class="bank-info" v-if="DOMAIN_NAME !== domainNameCurrent">
                    <div class="bank-change">
                      <span
                        ><b>{{ $t("new.title226") }}</b></span
                      >
                      <select v-model="activeBank" class="multiple_select_exam">
                        <option
                          v-for="(bankItem, index) in item.bankInfo"
                          :value="bankItem"
                          :key="index"
                          >{{ bankItem.nameBank }}</option
                        >
                      </select>
                    </div>
                    <div class="bank__info__detail">
                      <div class="bank-logo"></div>
                      <div class="bank-name">
                        <p>
                          <b>{{ bank[index].nameBank }}</b>
                        </p>
                        <p>
                          {{ $t("new.title223") }}: <br />
                          <span
                            ><b>{{ bank[index].nameAccount }}</b></span
                          >
                        </p>
                        <p>
                          {{ $t("new.title166") }}: <br /><span
                            ><b>{{ bank[index].numberBank }}</b></span
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="lessons">
                  <template v-for="(course, index) in item.courseInfo" >
                      <div class="lessons-info" :key="index">
                        <div class="lessons-name">
                          <span>{{ ++index }}</span>
                          <span>{{ course.courseName }}</span>
                        </div>
                        <div style="display: flex; align-items: center;">
                          <div
                          class="Stars"
                          :style="'--rating:' + course.courseEvaluate"
                        ></div>
                        <!-- Sao đánh giá -->
                        <div class="lessons-price" style="min-width: 30px;" >
                          <span data-label="$t('new.title177')">
                            {{ course.price > 0 ?
                              course.price
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ""
                            }}<span v-if="afterCurren">
                              {{ $t("new.title121") }}</span
                            ></span
                          >
                        </div>
                          <!-- <span v-if="item.offSelf !=0" :data-label="$t('new.title177')"><span v-if="beforeCurren">{{ $t("new.title121") }}</span> {{(item.coursePrice-item.coursePriceDiscount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}} <span v-if="afterCurren">{{ $t("new.title121") }}</span></span>
                                                  <span v-else :data-label="$t('new.title177')"><span v-if="beforeCurren">{{ $t("new.title121") }}</span> {{(item.coursePrice).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}} <span v-if="afterCurren">{{ $t("new.title121") }}</span></span> -->
                        </div>
                    </div>
                  </template>
                    <div class="synthetic" v-if="item.totalPrice >= 0">
                      <span class="ty"
                        ><span class="total_money"
                          >{{ $t("new.title155") }}: </span
                        ><span class="total_money"
                          ><span v-if="beforeCurren">
                            {{ $t("new.title121") }}</span
                          >
                          {{
                            item.totalPrice
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          }}
                          <span v-if="afterCurren" class="total_money">{{
                            $t("new.title121")
                          }}</span></span
                        ></span
                      >
                    </div>
                  </div>
                </li>
              </ul>
            </dir>
          </div>
        </div>
      </section>
    </div>
    <loading class="loading--lesson nqt-pst-a" :showLoading="!isLoadData" />
  </div>
</template>

<script>
import html2pdf from 'html2pdf.js';
import loading from "@/components/loading/loading";
import exportToPdf from "@/components/defineSelfCourse/exportInfoInvoiceToPdf/exportToPdf";
import domainName from "../../../env";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "Subscribe",
  props: {
    msg: String
  },
  components: {
      exportToPdf,
      loading
      },
  data() {
    return {
      outlineInfo: this.$route.query,
      listCourseName: eval("(" + this.$route.query.listCourseName + ")"),
      bankInfo: [],
      afterCurren: false,
      beforeCurren: false,
      activeBank: {},
      bank: [],
      dataRender: [],
      domainNameCurrent: window.location.host,
      DOMAIN_NAME: domainName.DOMAIN_NAME_SANRITSU,
      isLoadData: true,
      dataInsert : null,
      isInsert: false,
      QRCODE: null,
      isDisabled: false,
      transferCode: "",
      totalPrice: 0,
      mailto: "（+81）3-3304-4560"
    };
  },
  async created() {
    this.dataInsert = JSON.parse(localStorage.getItem("dataInsert"))
    this.isLoadData = false
    this.transferCode = sessionStorage.getItem("codeqr")
    while(this.bank.length <= 0) {
      if (this.transferCode != "") {
        if (this.outlineInfo.code != undefined) {
          if (this.outlineInfo.code.length > 0) {
            this.isInsert = true
            this.isDisabled = true
          }
        }
      }
      await this.init();
    }
    this.isLoadData = true
  },
  mounted() {
    this.checkCurren();
  },
  watch: {
    activeBank(newValue) {
      const temp = this.bank.map(el => {
        if (el.companyId == newValue.companyId) {
          return { ...newValue };
        } else {
          return { ...el };
        }
      });
      this.bank = temp;
    }
  },
  methods: {
    ...mapActions("applyCourse", ["updateData", "updateCode"]),
    async convertToPdf() {
      this.QRCODE = sessionStorage.getItem("codeqr")
      const content = this.$refs.pdfWrapper.innerHTML;
      const options = {
        margin: 10,
        filename: this.formatFileName(),
        image: { type: 'jpeg', quality: 1 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
      };

      await html2pdf().set(options).from(content).toPdf().output('blob').then((data) => {
        const pdfBlob = new Blob([data], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = this.formatFileName();
        link.click();
      })
    },
    async insertCourseRegisterUser() {
      try {
        this.isLoadData = false;
        await this.$api.get("/evaluate/getTransferCode").then((res) => {
          this.transferCode = res.data
          this.updateCode(this.transferCode)
          this.addQueryToURL(this.transferCode)
        })
        const courseName = []
        this.listCourseName.map((item, value) => {
          courseName.push(item.id)
        })
        const content = this.$refs.pdfWrapper.innerHTML;
        const options = {
          margin: 10,
          filename: this.formatFileName(),
          image: { type: 'jpeg', quality: 1 },
          html2canvas: { scale: 2 },
          jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
        };
  
         html2pdf().set(options).from(content).toPdf().output('blob').then((data) => {
          const pdfBlob = new Blob([data], { type: 'application/pdf' });
          const formData = new FormData();
          const listCourseIdNew = []
          this.dataInsert.listCourseId.map((item, value) => {
            const objListCourseIdNew = {
              courseId: item.courseId,
              coursePrice: item.coursePrice,
              coursePriceDiscount: item.coursePriceDiscount,
              offSelf: item.offSelf
            }
            listCourseIdNew.push(objListCourseIdNew)
          })
  
          const coursesBankInfoBoughtNew = []
          const objCoursesBankInfoBoughtNew = {
            companyId: this.activeBank.companyId,
            id: this.activeBank.id,
            nameAccount: this.activeBank.nameAccount,
            nameBank: this.activeBank.nameBank,
            numberBank: this.activeBank.numberBank,
            totalPrice: this.activeBank.totalPrice
          }
          coursesBankInfoBoughtNew.push(objCoursesBankInfoBoughtNew)
          this.isLoadData = false;
          formData.append('file', pdfBlob, this.formatFileName());
          if (this.dataInsert.userId != null) {
            formData.append('userId', this.dataInsert.userId)
          } else {
            formData.append('userId', "")
          }
          formData.append('userName', this.dataInsert.userName);
          formData.append('email', this.dataInsert.email);
          formData.append('mobile', this.dataInsert.mobile);
          formData.append('transferContent', null);
          formData.append('transferCode', this.transferCode);
          formData.append('listCourseId', JSON.stringify(listCourseIdNew));
          formData.append('money', this.dataInsert.money);
          formData.append('coursesBankInfoBought', JSON.stringify(coursesBankInfoBoughtNew));
          formData.append('languageType', this.$lang());
          formData.append('domainName', this.DOMAIN_NAME);
          this.$api.form("/evaluate/insertCourseRegisterUserSanrisu", formData)
              .then(response => {
                  if (response.data == "err") {
                    this.$el_alert_type(window.vm.$i18n.t("js.registerApplyCourseFalse"), "warning");
                    this.isLoadData = true;
                    return
                  }
                  this.isLoadData = true;
                  localStorage.clear();
                  this.dataInsert = null
                  sessionStorage.setItem("codeqr", this.transferCode)
                  this.QRCODE = this.transferCode
                  this.isInsert = true
                  this.isDisabled = true
                  this.updateData(response.data)
              })
              .catch(err => {
                this.$el_alert_type(window.vm.$i18n.t("js.registerApplyCourseFalse"), "warning");
                this.isLoadData = true;
                // console.log(err);
              });
          // this.openModal();
        })
      } catch(e) {
        this.$el_alert_type(window.vm.$i18n.t("js.registerApplyCourseFalse"), "warning");
        this.isLoadData = true;
      }
    },
    addQueryToURL(value) {
      const newQuery = "code=" + value;
      const currentURL = this.$route.fullPath;
      const newURL = currentURL.includes('?') ? `${currentURL}&${newQuery}` : `${currentURL}?${newQuery}`;
      this.$router.push(newURL);
    },
    formatFileName () {
      const date = new Date();
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      const formatDate = year + "_" + month + "_" + day
      return window.vm.$i18n.t("new.title288") + this.outlineInfo.name + '_' + formatDate +  '.PDF'
    },
    async init() {
      // this.bankInfo = await this.getCourseBankInfo();
      this.isLoadData = false;
      this.convertData();
      this.dataRender.forEach(val => {
        this.bank.push(val.bankInfo[0]);
      });
      this.isLoadData = true;
    },
    getCourseBankInfo() {
      return new Promise((resolve, reject) => {
        this.$api
          .post("/evaluate/getCourseBankInfo", {
            // courseId : this.outlineInfo.courseId
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(err => {
            reject(err.response);
          });
      });
    },
    convertData() {
      const courses = this.listCourseName.map(course => {
        return {
          companyId: course.courseBankInfo[0].companyId || null,
          ...course
        };
      });

      courses.forEach(course => {
        const companyExist = this.dataRender.some(
          el => el.companyId === course.companyId
        );
        if (companyExist) {
          this.dataRender.forEach(el => {
            if (el.companyId == course.companyId && course.price >= 0) {
              el.totalPrice += course.price;
              el.courseInfo.push(course);
              return el;
            }
          });
        } else {
          const obj = {
            companyId: course.companyId,
            totalPrice: course.price,
            bankInfo: course.courseBankInfo,
            courseInfo: [course]
          };
          this.activeBank = course.courseBankInfo[0];
          this.dataRender.push(obj);
        }
      });
    },
    openModal() {
      document.getElementById("myModal").style.display = "block";
    },
    closeModal() {
      document.getElementById("myModal").style.display = "none";
    },
    nextBackCourse() {
      localStorage.clear();
      this.$router.push({
        path: "/home",
        query: {}
      });
    },
    exportInfoSubscribe() {
      let tempList = [];

      const courses = this.listCourseName.map(value => {
        return {
          code: this.outlineInfo.code,
          email: this.outlineInfo.email,
          mobile: this.outlineInfo.mobile,
          name: this.outlineInfo.name,
          price: value.price,
          courseName: value.courseName,
          listBank: value.courseBankInfo
        };
      });

      courses.forEach(course => {
        course.listBank.forEach(item => {
          tempList.push({
            bank:
              item.nameBank +
              " ・ " +
              item.numberBank +
              " ・ " +
              item.nameAccount,
            ...course
          });
        });
      });

      var headerName = [
        {
          key: "courseName",
          value: "home.courseName"
        },
        {
          key: "price",
          value: "new.title153"
        },
        {
          key: "name",
          value: "personSet.userName"
        },
        {
          key: "email",
          value: "profile.email"
        },
        {
          key: "mobile",
          value: "new.title172"
        },
        // {
        //   key: "code",
        //   value: "new.title204"
        // },
        // {
        //   key: "bank",
        //   value: "new.title165"
        // }
      ];
      var params = {
        header: true,
        titles: [
          "courseName",
          "price",
          "name",
          "email",
          "mobile",
          "code",
          "bank"
        ],
        data: tempList,
        headerName: headerName,
        name: this.outlineInfo.name + "_" + this.outlineInfo.code + ".csv"
      };
      this.exportCsv(params);
    },
    // Curency position
    checkCurren() {
      if (this.$lang()) {
        if (this.$lang() == 3 || this.$lang() == 1) {
          this.beforeCurren = true;
        } else {
          this.afterCurren = true;
        }
      }
    }
  },
  computed: {
    ...mapGetters('applyCourse', ['getDataInsert']),
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal-confirm {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 3; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}

/* Modal Content */
.modal-content {
  background-color: #fefefe;
  margin: auto;
  top: 30%;
  transform: translateY(-30%);
  padding: 20px;
  border: 1px solid #888;
  width: 30%;
  border-radius: 10px;
  position: relative;
}

.close {
    color: #fff;
    float: right;
    font-size: 15px;
    font-weight: bold;
    border: 1px solid;
    /* border-color: gray; */
    border-radius: 7px;
    padding: 5px;
    background-color: #25368c;
    cursor: pointer;
    position:absolute;
    right: 5px;
    top: 5px;
}

select {
  margin-bottom: 1em;
  padding: 0.25em;
  border: 0;
  border-bottom: 2px solid currentcolor;
  font-weight: bold;
  letter-spacing: 0.15em;
  border-radius: 0;
  width: 200px;
}
select:focus,
select:active {
  outline: 0;
  border-bottom-color: #0071c5;
}
.table-info tr td:first-child {
  text-align: right;
}
.table-info tr td:last-child {
  text-align: left;
}
.container-subscribe {
  padding: 20px 0px;
  font-size: 16px;
}
.container-subscribe p {
  text-align: center;
  line-height: 24px;
}
.step-progress {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 40px 40px 40px;
}
.progress-container {
  display: flex;
  justify-content: space-between;
  position: relative;
  max-width: 100%;
  width: 550px;
}
.progress-container::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  height: 4px;
  width: 100%;
  background-color: #bbbbbb;
  z-index: -1;
}
.progress-container .progress {
  position: absolute;
  top: 50%;
  left: 0;
  width: 0;
  height: 4px;
  background-color: var(--line-border-fill);
  z-index: -1;
  transition: all 0.5s ease-in;
}

.circle {
  background-color: #fff;
  height: 100px;
  width: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  transition: all 0.4s ease-in;
  border: 7px solid #aaaaaa;
}
.circle.active {
  border-color: #0071c5;
  background-color: #fff;
  box-shadow: 0px 0px 31px -2px rgba(0, 105, 37, 0.62);
}
.container-subscribe .subscribe .subscribe-success {
  width: 100%;
  background-color: #0071c5;
  font-size: 36px;
  text-align: center;
  height: 70px;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}
.container-subscribe .subscribe .main {
  display: flex;
  flex-direction: column;
  padding: 2% 5% 2% 5%;
  background: #ffffff !important;
  border-radius: 30px;
  margin-bottom: 0px;
}
.container-subscribe .subscribe .main .image-notifi img {
  width: 80px;
  height: 80px;
  display: block;
  margin: 0px auto;
  padding: 10px;
}
.container-subscribe .subscribe .main .image-notifi h3 {
  text-align: center;
  color: #444444;
  font-size: 20px;
  padding: 20px;
  align-items: center;
}
.container-subscribe .subscribe .main .content-notifi {
  display: flex;
  justify-content: center;
  margin: 20px auto;
  width: 60%;
}
.container-subscribe .subscribe .main .content-notifi-tokyo {
    display: flex;
    margin: 20px auto;
    width: 65%;
    justify-content: center;
  }
.container-subscribe .subscribe .main .infor-customer {
  display: flex;
  text-align: center;
  column-gap: 15%;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
}
.container-subscribe .subscribe .main .infor-customer .info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.container-subscribe .subscribe .main .infor-customer .transfer-code {
  display: flex;
  flex-direction: column;
  color: #051367;
  font-size: 24px;
}
.container-subscribe .subscribe .main .infor-customer .transfer-code .code {
  border: 3px solid #051367;
  border-radius: 4px;
  font-size: 32px;
  font-weight: bold;
  padding: 10px;
  margin: 10px 0px;
}

.container-subscribe .subscribe .main .content-remind {
  display: block;
  margin: 20px auto;
  text-decoration: underline;
}
.container-subscribe .subscribe .main .transfer-total {
  display: block;
  color: #051367;
  font-size: 32px !important;
  font-weight: bold;
}

.modal-content .button-back{
  margin-top: 40px;
  display: flex;
  column-gap: 10%;
  justify-content: center;
  flex-wrap: wrap;
}

.modal-content .button-back button {
  text-decoration: none;
  background-color: #0071c5;
  color: #fff;
  font-size: 18px;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
  text-align: center;
  width: 235px;
  cursor: pointer;
  border: none;
  display: block;
}

.container-subscribe .subscribe .main .button-back {
  margin-top: 40px;
  display: flex;
  column-gap: 10%;
  justify-content: center;
  flex-wrap: wrap;
}
.container-subscribe .subscribe .main .button-back button {
  text-decoration: none;
  background-color: #0071c5;
  color: #fff;
  font-size: 18px;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
  text-align: center;
  width: 300px;
  cursor: pointer;
  border: none;
  display: block;
}

@media screen and (max-width: 600px) {
  .circle {
    width: 80px;
    height: 80px;
  }
  .container-subscribe p {
    text-align: center;
    line-height: 32px;
  }
  .content-notifi {
    display: block;
    margin: 50px 10px;
    width: 95%;
  }
  .content-remind {
    display: block;
    margin: 50px 10px;
    width: 95%;
  }
  .button-back {
    display: flex;
    flex-direction: column;
    margin: 0px auto;
    display: flex;
    width: 80%;
  }
  .button-back button {
    width: 90% !important;
    margin: 10px auto;
  }
  /* #export{
            display: none;
        } */
}
.header-tab {
  width: 100%;
  background-color: #dddddd;
  color: #000000;
  font-weight: bolder;
  font-size: 20px;
  margin-bottom: 10px;
}
.header-tab h3 {
  padding: 10px;
}
.bankLists {
  margin: 2% 5% 2% 5%;
}
.bankLists .bank ul li {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  column-gap: 40px;
  padding: 20px;
  flex-wrap: wrap;
  background: #ffffff;
  margin: 10px 0px 10px 0px;
  box-shadow: 5px 5px 5px #bbbbc3;
  border: 1px solid #d7d7d7;
  border-radius: 6px;
}
.bankLists .bank .bank-info {
  display: flex;
  width: 35%;
  min-width: 220px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.bankLists .bank .bank-info .bank-name {
  display: flex;
  column-gap: 20px;
  align-items: center;
  flex-direction: column;
}
.bank__info__detail {
  display: flex;
  width: 100%;
  column-gap: 20px;
  justify-content: center;
  align-items: center;
}
.bank__info__detail .bank-logo {
  background-image: url("../../../static/images/ic-bank1.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  float: left;
  font-size: 18px;
  min-width: 70px;
  height: 70px;
}
.bankLists .bank .bank-info .bank-change {
  display: flex;
  column-gap: 10px;
  align-items: center;
  font-size: 20px;
  color: #051367;
}
.bankLists .bank .bank-info .bank-change .change-logo {
  background-image: url("../../../static/images/sync64.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  float: left;
  font-size: 18px;
  min-width: 50px;
  height: 50px;
}
.bankLists .bank .lessons {
  margin-top: 0px;
  width: 60%;
  min-width: 410px;
  display: flex;
  flex-direction: column;
  font-weight: bold;
}
.bankLists .bank .lessons .lessons-info {
  margin-bottom: 10px;
  border-radius: 15px;
  padding: 10px 20px;
  background: #e8f9fd;
  display: flex;
  justify-content: space-between;
  column-gap: 5px;
  align-items: center;
}
.bankLists .bank .lessons .lessons-info .lessons-name {
  column-gap: 20px;
  display: flex;
  width: 50%;
}
.bankLists .bank .lessons .lessons-info .lessons-name span {
  word-break: break-word;
}
.bankLists .bank .lessons .lessons-info .Stars {
  width: 20%;
  min-width: 112px;
}
.bankLists .bank .lessons .lessons-info .lessons-price {
  width: 30%;
  min-width: 130px;
  display: flex;
  justify-content: flex-end;
}
.bankLists .bank .lessons .synthetic {
  background: #0071c5;
  color: #ffffff;
  margin: 10px 0px;
  padding: 0px 20px 0px 20px;
  height: 50px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  border-radius: 30px;
  justify-content: flex-end;
  align-items: center;
}
.Stars {
  --star-size: 20px;
  --star-color: #a8a8a8;
  --star-background: #ff6d35;
  --percent: calc(var(--rating) / 5 * 100%);
  display: inline-block;
  font-size: var(--star-size);
  font-family: Times;
  line-height: 1;
}
.Stars::before {
  content: "★★★★★";
  letter-spacing: 3px;
  background: linear-gradient(
    90deg,
    var(--star-background) var(--percent),
    var(--star-color) var(--percent)
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
@media (max-width: 550px) {
  .container-subscribe .subscribe .main .content-notifi {
    display: flex;
    justify-content: center;
    margin: 20px auto;
    width: 80%;
  }
  .container-subscribe .subscribe .main .content-notifi-tokyo {
    display: flex;
    margin: 20px auto;
    width: 80%;
  }
  .bankLists .bank .lessons .synthetic {
    justify-content: center;
  }
  .bankLists .bank.bank-new {
    padding-inline-start: 0px;
  }
  .bankLists .bank .lessons {
    margin-top: 0px;
    width: 100%;
    min-width: 0px;
    display: flex;
    flex-direction: column;
    font-weight: bold;
  }
  .bankLists .bank .lessons .lessons-info .Stars {
    visibility: hidden;
    display: none;
  }
}
#hidden {
  visibility: hidden;
  display: none;
}

.downloadExcel {
    text-decoration: none;
    background-color: #0071c5;
    color: #fff;
    font-size: 18px;
    padding: 10px;
    margin-bottom: 10px;
    border-radius: 5px;
    text-align: center;
    width: 300px;
    cursor: pointer;
    border: none;
    display: block;
}

.region-title {
  font-weight: bold;
  color: #051367
}

.region-info {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.region-info span {
  margin-left: 65px;
}

.region-bank {
  display: flex;
}

.bankLists-export_pdf {
  display: flex;
  justify-content: center !important;
}

.download-success {
  text-align: center;
  display: block;
  color: #051367;
  font-size: 20px !important;
  font-weight: bold;
}
.btn-01 {
    font-family: arial!important;
    min-width: 115px;
    line-height: 20px!important;
    padding: 6px 10px!important;
    font-size: 16px!important;
    border-radius: 6px!important;
    margin: 0 5px !important;
    color: #fff;
    font-weight: 500;
    border: none;
    background-color: #fa7641;
    width: 90%;
    cursor: default;
}

.button-insert-pdf {
  position: relative;
}

.info-contact {
  position: absolute;
  display: flex;
  flex-direction: column;
  width: 550px;
  color: red;
}

.info-bank-content {
  position: relative;
}

.info-bank-content span{
  display: inline;
  position: absolute;
  top: 3px;
  width: max-content;
}

.bank__info__content {
  justify-content: left !important;
}
</style>



// WEBPACK FOOTER //
// src/views/defineSelfCourse/subscribeSuccessSelfCourse.vue